import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AutopayBillingService } from '@services/my-insurance/autopay-billing.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-manage-autopay-imp-notice',
  templateUrl: './manage-autopay-imp-notice.component.html',
  styleUrls: ['./manage-autopay-imp-notice.component.css'],
})
export class ManageAutopayImpNoticeComponent implements OnInit {
  showAlertNotification = false;
  hideAlert = false;

  constructor(private autopayBillingService: AutopayBillingService) {}

  ngOnInit() {
    this.autopayBillingService.getAutopayAlert().subscribe((show) => {
      this.showAlertNotification = show;
    });
  }

  onClose(){
    this.hideAlert = true;
  }
}
